// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"612f53fa","732":"290f7b03","977":"c09917a9"}[chunkId] + ".chunk.js";
};